import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { routeTo } from 'dux/router/actions';
import { getUserAuthenticated } from 'dux/user/selectors';
import { getCurrentRouteType } from 'dux/router/selectors';

import Header from 'components/header';
import Footer from 'components/footer/footer';
import ProgramBranding from 'components/program-branding';
import ClientBranding from 'components/client-branding';
import {
    GOAL_SELECTION,
    LOGIN,
    LOGOUT,
    ERROR
} from 'dux/router/types';
// scss
import 'app/framework/scss/style.scss';

const HEADER_BLACKLIST = [ GOAL_SELECTION, LOGIN, ERROR ];
const FOOTER_BLACKLIST = [ GOAL_SELECTION, ERROR ];
const MOBILE_REGEXP = /android|iPad|iPhone|iPod/i;
/*******************************************************************************
 *  1. App (root level component)
 */

export class Layout extends React.Component {
    static propTypes = {
        location: PropTypes.shape( {
            pathname: PropTypes.string
        } ).isRequired,
        loadedRoute: PropTypes.string,
        routeTo: PropTypes.func.isRequired,
        authenticated: PropTypes.bool,
        children: PropTypes.node
    }

    static defaultProps = {
        children: null,
        authenticated: false,
        location: {
            pathname: ''
        }
    }

    checkIfLogout = () => {
        return this.props.loadedRoute === LOGOUT;
    }

    shouldShowHeader = () => this.props.authenticated && !HEADER_BLACKLIST.includes( this.props.loadedRoute );
    shouldShowFooter = () => !FOOTER_BLACKLIST.includes( this.props.loadedRoute );

    render() {
        const { authenticated, location } = this.props;
        const routename = ( location.pathname || '' )
            .replace( /\/$/, '' )
            .split( '/' )
            .pop();
        return (
            <section className={ classNames(
                `${ routename }-active-section`,
                'active-section',
                {
                    'is-mobile': MOBILE_REGEXP.test( navigator.userAgent )
                }
            ) }>

                <ProgramBranding scopingSelector={`.${ routename }-active-section`} />
                <ClientBranding scopingSelector={`.${ routename }-active-section`} />

                { this.shouldShowHeader() &&
                    <Header authenticated={ authenticated } />
                }

                <section className="main-content">
                    { this.props.children }
                </section>

                {/*<SessionModal authenticated={ authenticated } />*/}

                { this.shouldShowFooter() &&
                    <Footer showLinks={ !this.checkIfLogout() } routeTo={ this.props.routeTo } />
                }
            </section>
        );
    }
}

export const mapStateToProps = ( state ) => {
    return {
        location: state.location,
        loadedRoute: getCurrentRouteType( state ),
        authenticated: getUserAuthenticated( state )
    };
};

export const mapDispatchToProps = {
    routeTo
};

export default connect( mapStateToProps, mapDispatchToProps )( Layout );
